<template>
<div>

</div>
</template>

<script>
export default {
    name: "viewControl",
    mounted: function(){
        this.init();
    },
    data: function(){
        return {
            controller: null
        }
    },
    methods: {
        init: function(){
            var self = this;
            self.controller = new this.source(self);
            self.$controller.view = this.controller;
            self.$controller.view.init();
        },


        source: function(self){
            var view = this;
            var timer = null;

            this.reportWindowSize = function(){
                clearTimeout(timer);
                timer = setTimeout(function(){
                self.$store.dispatch('window',{
                    height: window.innerHeight,
                    width: window.innerWidth          
                });
                },50)        
            }

            this.login = new function(){
                var login = this;
                login.callBacks = {
                    onSuccess: null
                };
                login.referrer = null;

                this.onSuccess = function(){
                    if(typeof login.callBacks.onSuccess=='function'){
                        setTimeout(function(view){
                            login.callBacks.onSuccess();
                            login.callBacks.onSuccess = null;
                            login.referrer = null;
                        },1000)
                    }
                }

                this.open = function(onSuccess=null, referrer=null){
                    login.callBacks.onSuccess = onSuccess;
                    login.referrer = referrer;
                    self.$store.dispatch('login',true);
                }

                this.close = function(){
                    self.$store.dispatch('login',false);
                }
            }

            this.loginRep = new function(){
                this.open = function(){
                self.$store.dispatch('loginRep',true);
                }

                this.close = function(){
                self.$store.dispatch('loginRep',false);
                }
            }

            this.registration = new function(){
                this.open = function(){
                self.$store.dispatch('login',true);
                }

                this.close = function(){
                self.$store.dispatch('login',false);
                }
            }

            this.programAdmin = new function(){
                this.open = function(){
                self.$store.dispatch('programAdmin',true);
                }
                this.close = function(){
                self.$store.dispatch('programAdmin',false);
                }
            }

            this.programAdminQuickAccess = new function() {
                this.open = function() {
                    self.$store.dispatch('programAdminQuickAccess', true);
                }

                this.close = function() {
                    self.$store.dispatch('programAdminQuickAccess', false);
                }
            }

            this.contactUs = new function() {
                this.open = function() {
                    self.$store.dispatch('contactUs', true);
                }

                this.close = function() {
                    self.$store.dispatch('contactUs', false);
                }
            }
            
            this.SiteRegulation = new function() {
                this.open = function(regulationTargetTab) {
                    if (regulationTargetTab !== undefined){
                        self.$store.dispatch('siteRegulationTargetTab', regulationTargetTab);
                    }
                    self.$store.dispatch('siteRegulation', true);
                }

                this.close = function() {
                    self.$store.dispatch('siteRegulation', false);
                }
            }
            
            this.accountValidation = new function() {
                this.open = function() {
                    self.$store.dispatch('accountValidation', true);
                }

                this.close = function() {
                    self.$store.dispatch('accountValidation', false);
                }
            }

            this.accountValidationError = new function() {
                this.open = function() {
                    self.$store.dispatch('accountValidationError', true);
                }

                this.close = function() {
                    self.$store.dispatch('accountValidationError', false);
                }
            }

            this.editProfile = new function() {
                this.open = function() {
                    self.$store.dispatch('editProfile', true);
                }

                this.close = function() {
                    self.$store.dispatch('editProfile', false);
                }
            }

            this.init = function(){
                view.reportWindowSize();
                window.addEventListener('resize',this.reportWindowSize);
            }
        
        },
    }
}
</script>

<style>

</style>